"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var RailCarTankCoupledDrive = function RailCarTankCoupledDrive(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "54.78",
    height: "24",
    viewBox: "0 0 54.78 24",
    fill: "#93c01f"
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "Zug_"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M37,22.44a2.35,2.35,0,0,0,.5-4.65l-.56-.05a2.35,2.35,0,0,0,.06,4.7Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M44.88,22.44a2.34,2.34,0,0,0,.57-4.62H44.3a2.35,2.35,0,0,0,.58,4.62Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.88,17.74l-.56.05a2.36,2.36,0,1,0,.56-.05Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.48,17.82H9.33a2.35,2.35,0,1,0,1.15,0Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.26,15.39v-.72a8.33,8.33,0,0,1-3,2.39,3.25,3.25,0,0,1,.39.35h6a.78.78,0,0,1,.78.78.78.78,0,0,1,.78-.78h6a3.25,3.25,0,0,1,.39-.35A8.23,8.23,0,0,1,30,11.38L25.53,14Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M27.39,18.23v0Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.26,4.5a8.21,8.21,0,0,0-6.43-3.11H13V.75A.76.76,0,0,0,12.26,0H8A.75.75,0,0,0,7.2.75v.64H0V2.88H16.83a6.72,6.72,0,0,1,6.43,4.79V4.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M27.39,18.23v0h0a.78.78,0,0,0-.78-.78h-6a3.25,3.25,0,0,0-.39-.35,8.33,8.33,0,0,0,3-2.39V11.45A6.72,6.72,0,0,1,18,16.2l-.22,0a3.45,3.45,0,0,0-1,.14h-6a3.43,3.43,0,0,0-1.94,0H0v4.47H6.06a3.91,3.91,0,1,0,7-3h1.58A3.9,3.9,0,0,0,17.82,24a3.92,3.92,0,0,0,3.91-3.91A4,4,0,0,0,21.55,19h5.09a.76.76,0,0,0,.75-.75ZM9.9,22.44a2.34,2.34,0,0,1-.57-4.62h1.15a2.35,2.35,0,0,1-.58,4.62Zm7.92,0a2.35,2.35,0,0,1-.5-4.65l.56-.05a2.35,2.35,0,0,1-.06,4.7Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38,2.88H54.78V1.39h-7.2V.75A.75.75,0,0,0,46.83,0H42.52a.76.76,0,0,0-.75.75v.64H38a8.22,8.22,0,0,0-8,6.4l.85.51.52.32A6.73,6.73,0,0,1,38,2.88Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M30,11.38a8.23,8.23,0,0,0,4.57,5.68,3.25,3.25,0,0,0-.39.35h-6a.78.78,0,0,0-.78.78h0v0h0a.75.75,0,0,0,.75.75h5.09a4,4,0,0,0-.18,1.11,3.91,3.91,0,1,0,7.08-2.27h1.58a3.9,3.9,0,1,0,7,3h6.06V16.32H45.85a3.45,3.45,0,0,0-1-.14,3.57,3.57,0,0,0-1,.14h-6a3.45,3.45,0,0,0-1-.14l-.22,0a6.7,6.7,0,0,1-5.42-5.64l-.53.32ZM44.3,17.82h1.15a2.35,2.35,0,1,1-1.15,0Zm-7.4-.08.56.05a2.36,2.36,0,1,1-.56-.05Z"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "29.74 9.42 24.76 6.43 24.76 7.49 24.76 11.69 24.76 12.74 29.74 9.76 30.02 9.59 29.74 9.42"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "24.76 12.74 24.76 12.74 29.74 9.76 29.74 9.76 24.76 12.74",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "29.74 9.76 30.02 9.59 29.74 9.76 29.74 9.76",
    fill: "#fff"
  }));
};

var _default = RailCarTankCoupledDrive;
exports["default"] = _default;